import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { BrowserRouter } from "react-router-dom";
import { THEME_CONFIG } from "./configs/AppConfig";
import { App as AntApp } from 'antd';
import history from "./history";
import "./lang";
import Layouts from "./layouts";

const themes = {
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  return (
    <AntApp>
      <div className="App">
        <BrowserRouter history={history}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Layouts />
          </ThemeSwitcherProvider>
        </BrowserRouter>
      </div>
    </AntApp>
  );
}

export default App;
